import print from './print.vue';
import printCommon from './print-common.vue';

export default {
  install(application) {
    const { app, filters } = application.config.globalProperties;
    Object.assign(app.buildPrint.template.defaults.imports, filters);
    application.component('yx-print', print);
    application.component('yx-print-new', printCommon);
  },
};
